import AccordionSection, { AccordionSectionProps } from "@insite/mobius/AccordionSection/AccordionSection";
import omitMultiple from "@insite/mobius/utilities/omitMultiple";
import MinusCircleFaq from "@SupplyLand/Icons/MinusCircleFaq";
import PlusCircleFaq from "@SupplyLand/Icons/PlusCircleFaq";
import React, { PropsWithChildren } from "react";
import { css } from "styled-components";

type State = Pick<AccordionSectionProps, "expanded">;

/**
 * FAQ-specific accordion component with custom styling and icons
 */
class FaqAccordion extends React.Component<
    PropsWithChildren<AccordionSectionProps & { initialExpanded?: boolean }>,
    State
> {
    state = { expanded: this.props.initialExpanded };

    toggle = () => {
        this.setState(
            ({ expanded }) => {
                return { expanded: !expanded };
            },
            () => {
                if (this.props.onTogglePanel) {
                    this.props.onTogglePanel(this.state.expanded ?? false);
                }
            },
        );
    };

    render() {
        return (
            <AccordionSection
                {...omitMultiple(this.props, ["onTogglePanel", "expanded", "initialExpanded"])}
                expanded={this.state.expanded}
                onTogglePanel={this.toggle}
                toggleIconProps={{ size: 50 }}
                expandIconProps={{ src: PlusCircleFaq }}
                collapseIconProps={{ src: MinusCircleFaq }}
                toggleTransition={{
                    positionerCss: css`
                        /* overrides IconPositioner just for this instance */
                        position: absolute;
                        right: 16px;
                        top: 50%;
                        transform: translateY(-50%);
                        padding-left: 0; /* kill default 15px */
                    `,
                    transitionCss: css`
                        /* overrides TransitionManager so it centers vertically */
                        top: 50%;
                        bottom: auto;
                        right: 0;
                        transform: translateY(-50%);
                    `,
                }}
                headerProps={{
                    css: css`
                        button {
                            position: relative;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    `,
                }}
                panelProps={{
                    css: css`
                        margin: 0;
                        padding: 15px;
                        border: 0;
                        border-top: 0;
                        display: ${this.state.expanded ? "block" : "none"};
                    `,
                }}
            />
        );
    }
}

export default FaqAccordion;
